<template lang="pug">
.div
	h4 Información de contacto
	.row
		.col
			.form-group
				label <b>Teléfono</b>
				input.form-control(type="tel" v-model="usuario.telefono")
		.col
			.form-group
				label <b>Email</b>
				input.form-control(type="email" v-model="usuario.email")
	.row
		.col
			.form-group
				label Pushover user key
				input.form-control(type="text" v-model="usuario.pushover")
	hr
	h4 Detalles de acceso
	//.alert.alert-warning(v-if="ldap")
		span.fa.fa-warning.mr-2
		|Esta cuenta está vinculada con un directorio LDAP, por ello algunas opciones no estarán disponibles.
		br
		.text-right
			button.btn.btn-sm.btn-danger(@click="eliminarLdap()")
				span.fa.fa-trash.mr-2
				|Eliminar entrada LDAP
	//.alert.alert-info(v-if="!ldap && usuario.ID")
		span.fa.fa-info-circle.mr-2
		|Esta cuenta no tiene una entrada en el directorio LDAP. Si quieres que este usuario pueda loggearse en los equipos Linux y Windows de la empresa
		|debes crearla.
		br
		.text-right
			button.btn.btn-sm.btn-primary.mt-2(@click="crearLdap()")
				span.fa.fa-edit.mr-2
				|Crear entrada LDAP
	.row
		.col
			.form-group
				label <b>Usuario</b>
				.input-group
					input.form-control(type="text" v-model="usuario.usuario" disabled="" placeholder="Se generará automáticamente")
					.input-group-append
						button.btn(:class="(usuario.admin) ? 'btn-primary' : 'btn-default'" @click="usuario.admin = !usuario.admin")
							|Admin
		.col
			label <b>Caducidad de la cuenta</b>
			.input-group.input-group-sm
				datepicker(
				:monday-first="true"
				:language='$dateLang'
				format="dd-MM-yyyy"
				:bootstrap-styling="true"
				placeholder="DD-MM-YYYY"
				v-model="usuario.fecha_expiracion_cuenta")
				.input-group-append(v-if="usuario.fecha_expiracion_cuenta <= new Date()")
					span.input-group-text.bg-danger.text-white
						|Caducada
	.row
		.col
			.form-group
				label <b>Password</b>
				button.btn.btn-block.btn-danger(@click="resetPassword()")
					|Generar nuevo password
			hr
			b 2º factor de autenticación
			br
			.mt-3.alert.alert-info(v-if="usuario.otps === 'ok'")
				b Activado
				br
				|Este usuario tiene un segundo factor de autentificación activado.
				hr
				button.btn.btn-sm.btn-danger(@click="quitaOTP()")
					span.fa.fa-trash.mr-2
					|Eliminar
			.mt-3.alert.alert-danger(v-if="usuario.otps !== 'ok'")
				b No activado
				br
				|Este usuario no tiene activado un segundo factor de autentificación. Por este motivo no podrá
				|acceder al SIP desde el exterior de la empresa
		.col
			.form-group
				label <b>Periodo validez password</b>
				.input-group
					input.form-control(type="number" v-model="usuario.periodo_password")
					.input-group-append
						span.input-group-text
							|días
			.form-group
				label <b>Póximo cambio de password</b>
				datepicker(
				:monday-first="true"
				:language='$dateLang'
				format="dd-MM-yyyy"
				:bootstrap-styling="true"
				placeholder="DD-MM-YYYY"
				v-model="usuario.caduca_password")
	.text-right.mt-2
		button.btn.btn-primary(@click="guardar()")
			span.fa.fa-save.mr-2
			|Guardar cambios
</template>

<style>
.vdp-datepicker .input-group > input {
	background-color: white !important;
}
</style>

<script>
import API from '../api'

export default {
	props: ['usuario'],
	// props: ['usuario', 'ldap'],

	methods: {
		guardar () {
			API.setUsuario(this.usuario)
				.then(res => {
					console.log(res)
					res.data.usuario.fecha_nacimiento = (res.data.usuario.fecha_nacimiento) ? new Date(res.data.usuario.fecha_nacimiento * 1000) : null
					res.data.usuario.caduca_password = (res.data.usuario.caduca_password) ? new Date(res.data.usuario.caduca_password * 1000) : null
					res.data.usuario.fecha_expiracion_cuenta = (res.data.usuario.fecha_expiracion_cuenta) ? new Date(res.data.usuario.fecha_expiracion_cuenta * 1000) : null

					this.$emit('update:usuario', res.data.usuario)
					// this.$emit('update:ldap', res.data.ldap)
					this.$store.commit('alertas/alert', {
						titulo: 'Correcto',
						mensaje: 'Se han guardado los cambios'
					})
				})
				.catch(e => {
					console.log(e)
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		/* crearLdap () {
			API.crearLdap(this.usuario.ID, this.usuario.usuario)
				.then(res => {
					this.$store.commit('alertas/alert', {
						titulo: 'Correcto',
						mensaje: 'Se ha creado el objecto en el directorio correctamente'
					})
					this.$emit('update:ldap', res.data.ldap)
					this.$emit('update:usuario', res.data.usuario)
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		eliminarLdap () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar usuario LDAP',
				mensaje: `¿Estás seguro de que quieres eliminar este usuario del directorio LDAP?

				Una vez eliminado no podrá loggearse en los equipos Linux ni Windows`,
				callback: (acepta) => {
					if (acepta) {
						API.eliminaLdap(this.usuario.ID)
							.then(res => {
								this.$store.commit('alertas/alert', {
									titulo: 'Correcto',
									mensaje: 'Se ha eliminado el usuario del directorio LDAP'
								})
								this.$emit('update:ldap', null)
							})
							.catch(e => {
								this.$store.commit('alertas/error', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		}, */
		resetPassword () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Confirmación',
				mensaje: '¿Quieres generar una contraseña aleatoria para este usuario?',
				callback: (acepta) => {
					if (acepta) {
						const datos = {
							usuario: this.usuario.usuario,
							ID: this.usuario.ID
						}

						API.resetPassword(datos)
							.then(res => {
								this.$store.commit('alertas/alert', {
									titulo: 'Password temporal',
									mensaje: 'El nuevo password temporal es: ' + res.data.nuevo_pass
								})
							})
							.catch(e => {
								this.$store.commit('alertas/error', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		},

		quitaOTP () {
			API.delOTP(this.usuario.ID)
				.then(res => {
					this.$emit('update:usuario', res.data.usuario)
					this.$store.commit('alertas/alert', {
						titulo: 'Correcto',
						mensaje: 'Se ha eliminado el segundo factor de autentificación de este usuario'
					})
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-usuarios/vue/editor/general.vue